import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";

import { getGroupsByIdList } from "../store/ducks/duckGroups";
import { getMenuItemGroups } from "../store/ducks/duckMenuItemGroup";
import { useUser } from "../auth/UserProvider";
import { getUsers } from "../store/ducks/duckUsers";
import incident from "../store/ducks/duckInvgate";
import NavBar from "../components/Navbar";
import { cleanUnauthorized } from "../store/ducks/duckError";
import { getMenuItems } from "../store/ducks/duckMenuItem";

export const Unauthorized = ({ location }) => {
  const dispatch = useDispatch();
  const { networkUser } = useUser();
  const menuItemsGroups = useSelector((state) => state.menuItemGroup.data);
  const [firstRender, setFirstRender] = useState(true);
  const users = useSelector((state) => state.users.data);
  const [ticketGenerated, setTicketGenerated] = useState(false);
  const menuItems = useSelector((state) => state.menuItem.data);
  const [solicitedLayout, setSolicitedLayout] = useState(null);
  const id = location.state;
  const path = localStorage.getItem("Path").toLowerCase();
  const isCustom = path == "/annual" || path == "/pre" || !id ? true : false;
  const groups = useSelector((state) => state.groups.data);

  useEffect(() => {
    if (firstRender) {
      dispatch(getUsers(networkUser));
      dispatch(getMenuItems());
      dispatch(getMenuItemGroups());
      dispatch(cleanUnauthorized());
      setFirstRender(false);
    }
  }, [networkUser]);

  function getLabelCustom(pathname) {
    if (pathname == "/pre") {
      return menuItems?.filter((x) => x.name.indexOf("PRE") >= 0)[0];
    } else if (pathname == "/annual") {
      return menuItems?.filter((x) => x.name.indexOf("Annual") >= 0)[0];
    } else {
      return menuItems?.filter((x) => x.name.indexOf("HR") >= 0)[0];
    }
  }

  const solicited = !isCustom
    ? menuItems?.filter((x) => x.layoutId == id)[0]
    : getLabelCustom(path);

  useEffect(() => {
    if (solicited) {
      setSolicitedLayout(solicited);
    }
  }, [solicited]);

  const getIdGroups = useCallback(() => {
    return menuItemsGroups
      ?.filter((x) => x.menuItemId == solicitedLayout?.id)
      .map((x) => x.groupId);
  }, [menuItemsGroups, solicitedLayout?.id]);

  useEffect(() => {
    if (menuItemsGroups && getIdGroups().length > 0) {
      dispatch(getGroupsByIdList(getIdGroups()));
    }
  }, [menuItemsGroups, dispatch, getIdGroups]);

  const handleTicket = () => {
    let invgateDescription = {
      id: 0,
      networkUser: networkUser,
      email: users[0] ? users[0].emailAddress : "",
      solicitedLayout: solicitedLayout.name,
      Groups: groups,
    };

    dispatch(incident(invgateDescription)).then(setTicketGenerated(true));
  };

  return (
    <>
      <NavBar />
      <Grid
        container
        alignContent="center"
        alignItems="center"
        direction="column"
        justify="center"
        style={{
          minHeight: "calc(100% - 64px)",
          paddingLeft: "10vw",
          paddingTop: 88,
          paddingRight: "10vw",
          maxWidth: "100vw",
        }}
      >
        <Grid item>
          <Typography color="error" style={{ widht: "100%" }} variant={"h2"}>
            Access denied
          </Typography>
        </Grid>
        <Divider
          style={{ backgroundColor: "black", width: "60%", marginBottom: 20 }}
          variant="fullWidth"
        />
        <Grid item>
          <Typography
            color="textSecondary"
            style={{ widht: "100%", paddingBottom: 10 }}
            variant={"h5"}
          >
            We are sorry but you do not have permissions or belong to the necessary groups to access
            this page.{" "}
          </Typography>
          <Typography
            color="textPrimary"
            style={{ widht: "100%", paddingBottom: 10, paddingLeft: 350 }}
            variant={"h5"}
          >
            Solicited Menu Item : {solicitedLayout?.name}
          </Typography>
          <Typography
            color="textPrimary"
            style={{ widht: "100%", paddingBottom: 5, paddingLeft: 350 }}
            variant={"h5"}
          >
            Possible assignment groups :
            <ul>
              {" "}
              {groups?.map((x) => {
                let label = (
                  <li>
                    {x.name} (
                    {x.owners?.map((x) => {
                      let ownerLabel = `${x.firstName} - ${x.lastName}`;

                      return ownerLabel;
                    })}
                    )
                  </li>
                );

                return label;
              })}
            </ul>
          </Typography>

          <Typography
            align="center"
            color="primary"
            style={{ widht: "100%", paddingBottom: 10 }}
            variant={"h5"}
          >
            To automatically generate a ticket in invgate requesting permissions,
          </Typography>
          <Typography
            align="center"
            color="primary"
            style={{ widht: "100%", paddingBottom: 10 }}
            variant={"h5"}
          >
            Click on the following button:
          </Typography>
        </Grid>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
          style={{ paddingTop: 30 }}
          xs={12}
        >
          <Grid>
            {!ticketGenerated ? (
              <Button
                color="primary"
                endIcon={<Icon>send</Icon>}
                variant="contained"
                onClick={() => handleTicket()}
              >
                Generate Ticket
              </Button>
            ) : (
              <Button disabled variant="contained">
                Ticket request sent successfully.
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
